import React from 'react';
import { Helmet } from 'react-helmet';

const TermsAndConditions: React.FC = () => {
  return (
    <div className="space-y-6">
      <Helmet>
        <title>Termeni și condiții</title>
      </Helmet>

      <div className="space-y-2">
        <h1 className="text-2xl font-semibold">Termeni și condiții</h1>
        <p className="text-sm text-muted-foreground">Ultima actualizare: 11 februarie 2026</p>
      </div>

      <div className="rounded-lg border border-border bg-card p-4 text-sm">
        <div className="font-semibold">Operator / Furnizor</div>
        <div className="mt-2 space-y-1 text-muted-foreground">
          <div>
            <span className="text-foreground">Global Linknet SRL</span>
          </div>
          <div>Sediu: județul Argeș, Pitești, Str. Dorobanților, nr. 14, bl. 51, et. 1, ap. 8</div>
          <div>Registrul Comerțului: J03/1287/2023</div>
          <div>CUI: 48291648</div>
          <div>
            E-mail: <span className="text-foreground">office@globallinknet.ro</span>
          </div>
        </div>
      </div>

      <section className="space-y-3 text-sm">
        <h2 className="text-lg font-semibold">1. Acceptarea termenilor</h2>
        <p className="text-muted-foreground">
          Prin accesarea sau utilizarea Platformei <span className="text-foreground">Scola</span> („Platforma”) confirmi că
          ai citit, ai înțeles și accepți acești Termeni și condiții. Dacă nu ești de acord, te rugăm să nu utilizezi
          Platforma.
        </p>
      </section>

      <section className="space-y-3 text-sm">
        <h2 className="text-lg font-semibold">2. Cine poate folosi Platforma</h2>
        <ul className="list-disc pl-5 space-y-2 text-muted-foreground">
          <li>
            Platforma este destinată mediului educațional (școli, profesori, elevi, părinți/tutori, administratori).
          </li>
          <li>
            În cazul utilizatorilor minori, accesul și utilizarea se realizează în cadrul regulilor școlii și/sau cu
            implicarea părinților/tutorilor, după caz.
          </li>
        </ul>
      </section>

      <section className="space-y-3 text-sm">
        <h2 className="text-lg font-semibold">3. Conturi, autentificare, securitate</h2>
        <ul className="list-disc pl-5 space-y-2 text-muted-foreground">
          <li>Contul este personal. Nu partaja credențiale și nu folosi contul altcuiva.</li>
          <li>Ești responsabil(ă) pentru activitatea din contul tău și pentru păstrarea confidențialității parolei.</li>
          <li>Putem suspenda accesul în caz de abuz, fraudă, încălcări repetate sau riscuri de securitate.</li>
        </ul>
      </section>

      <section className="space-y-3 text-sm">
        <h2 className="text-lg font-semibold">4. Reguli de utilizare (conduită)</h2>
        <ul className="list-disc pl-5 space-y-2 text-muted-foreground">
          <li>Respectă un limbaj adecvat mediului școlar.</li>
          <li>Interzis: hărțuire, discriminare, amenințări, conținut ilegal, sexual explicit, violent sau instigator.</li>
          <li>Interzis: acces neautorizat, ocolirea limitărilor, atacuri sau exploatarea vulnerabilităților.</li>
          <li>Respectă confidențialitatea informațiilor educaționale (note, absențe, mesaje, date personale).</li>
        </ul>
      </section>

      <section className="space-y-3 text-sm">
        <h2 className="text-lg font-semibold">5. Conținut și drepturi de autor</h2>
        <div className="space-y-3 text-muted-foreground">
          <p>
            Ești responsabil(ă) pentru conținutul pe care îl încarci sau îl distribui (postări, comentarii, fișiere,
            mesaje). Nu încărca materiale piratate sau pentru care nu ai drept de distribuire.
          </p>
          <p>
            Putem elimina conținutul care încalcă regulile și putem aplica măsuri conform Regulamentului platformei.
          </p>
        </div>
      </section>

      <section className="space-y-3 text-sm">
        <h2 className="text-lg font-semibold">6. Abonamente și acces</h2>
        <div className="space-y-3 text-muted-foreground">
          <p>
            Platforma poate include planuri de acces (de ex. Free/Basic/Full) sau implementări personalizate pentru școli
            (B2B). Accesul la anumite funcționalități poate fi limitat în funcție de plan sau de configurarea școlii.
          </p>
          <p>
            Detaliile comerciale sunt prezentate în pagina „Abonamente & implementare”. Pentru școli, condițiile se pot
            stabili prin ofertă/contract separat.
          </p>
        </div>
      </section>

      <section className="space-y-3 text-sm">
        <h2 className="text-lg font-semibold">7. Protecția datelor</h2>
        <p className="text-muted-foreground">
          Prelucrarea datelor cu caracter personal se face conform Politicii de confidențialitate, informațiilor GDPR și
          Politicii de cookies disponibile în Platformă.
        </p>
      </section>

      <section className="space-y-3 text-sm">
        <h2 className="text-lg font-semibold">8. Limitarea răspunderii</h2>
        <p className="text-muted-foreground">
          În măsura permisă de lege, Furnizorul nu răspunde pentru prejudicii indirecte rezultate din utilizarea sau
          imposibilitatea utilizării Platformei ori din factori externi (ex.: întreruperi internet, defecțiuni
          echipamente).
        </p>
      </section>

      <section className="space-y-3 text-sm">
        <h2 className="text-lg font-semibold">9. Suspendare/încetare</h2>
        <p className="text-muted-foreground">
          Putem suspenda sau înceta accesul la Platformă în cazul încălcării Termenilor, al solicitării școlii (B2B) sau
          când este necesar pentru securitate ori conformitate legală.
        </p>
      </section>

      <section className="space-y-3 text-sm">
        <h2 className="text-lg font-semibold">10. Legea aplicabilă</h2>
        <p className="text-muted-foreground">
          Acești Termeni sunt guvernați de legea română. Orice litigiu se va soluționa cu prioritate pe cale amiabilă, iar
          în lipsa unui acord, de instanțele competente.
        </p>
      </section>
    </div>
  );
};

export default TermsAndConditions;

